import { RatingsIntervalType, RatingsRatingType, formatRatingsApiDate, getYesterdayDate } from 'shared/pages/Ratings/const';

export enum ShowcaseFilterType {
    likes = 0,
    views = 1,
}

export const showcaseFilterToRatingType: Record<ShowcaseFilterType, RatingsRatingType> = {
    [ShowcaseFilterType.likes]: RatingsRatingType.likes,
    [ShowcaseFilterType.views]: RatingsRatingType.views,
};

export interface IShowcaseRatingsFilter {
    ratingType: ShowcaseFilterType;
    date: string | null;
    intervalType?: number | null;
    dateFrom?: string | null;
    dateTo?: string | null;
    monthValue?: string | null;
}

export const initialRatingsFilter: IShowcaseRatingsFilter = (() => {
    const yesterday = getYesterdayDate();
    return {
        ratingType: ShowcaseFilterType.views,
        intervalType: RatingsIntervalType.day,
        date: formatRatingsApiDate(yesterday),
        dateFrom: yesterday.toISOString(),
        dateTo: yesterday.toISOString(),
        monthValue: null,
    };
})();

/** Прошедшая неделя: понедельник–воскресенье до текущей */
const getLastWeekRangeMonSun = (): [Date, Date] => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const day = today.getDay();
    const thisMondayOffset = day === 0 ? -6 : 1 - day;
    const thisMonday = new Date(today);
    thisMonday.setDate(today.getDate() + thisMondayOffset);

    const lastMonday = new Date(thisMonday);
    lastMonday.setDate(thisMonday.getDate() - 7);
    const lastSunday = new Date(lastMonday);
    lastSunday.setDate(lastMonday.getDate() + 6);

    return [lastMonday, lastSunday];
};

export const initialRatingsFilterByWeek: IShowcaseRatingsFilter = (() => {
    const [from, to] = getLastWeekRangeMonSun();
    return {
        ratingType: ShowcaseFilterType.views,
        intervalType: RatingsIntervalType.week,
        date: formatRatingsApiDate(from),
        dateFrom: from.toISOString(),
        dateTo: to.toISOString(),
        monthValue: null,
    };
})();import { RatingsIntervalType, RatingsRatingType, formatRatingsApiDate, getYesterdayDate } from 'shared/pages/Ratings/const';

export enum ShowcaseFilterType {
    likes = 0,
    views = 1,
}

export const showcaseFilterToRatingType: Record<ShowcaseFilterType, RatingsRatingType> = {
    [ShowcaseFilterType.likes]: RatingsRatingType.likes,
    [ShowcaseFilterType.views]: RatingsRatingType.views,
};

export interface IShowcaseRatingsFilter {
    ratingType: ShowcaseFilterType;
    date: string | null;
    intervalType?: number | null;
    dateFrom?: string | null;
    dateTo?: string | null;
    monthValue?: string | null;
}

export const initialRatingsFilter: IShowcaseRatingsFilter = (() => {
    const yesterday = getYesterdayDate();
    return {
        ratingType: ShowcaseFilterType.views,
        intervalType: RatingsIntervalType.day,
        date: formatRatingsApiDate(yesterday),
        dateFrom: yesterday.toISOString(),
        dateTo: yesterday.toISOString(),
        monthValue: null,
    };
})();

/** Прошедшая неделя: понедельник–воскресенье до текущей */
const getLastWeekRangeMonSun = (): [Date, Date] => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const day = today.getDay();
    const thisMondayOffset = day === 0 ? -6 : 1 - day;
    const thisMonday = new Date(today);
    thisMonday.setDate(today.getDate() + thisMondayOffset);

    const lastMonday = new Date(thisMonday);
    lastMonday.setDate(thisMonday.getDate() - 7);
    const lastSunday = new Date(lastMonday);
    lastSunday.setDate(lastMonday.getDate() + 6);

    return [lastMonday, lastSunday];
};

export const initialRatingsFilterByWeek: IShowcaseRatingsFilter = (() => {
    const [from, to] = getLastWeekRangeMonSun();
    return {
        ratingType: ShowcaseFilterType.views,
        intervalType: RatingsIntervalType.week,
        date: formatRatingsApiDate(from),
        dateFrom: from.toISOString(),
        dateTo: to.toISOString(),
        monthValue: null,
    };
})();